import React, { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../services/msalConfig';
import { Box, Button, Card, CardContent, Typography, CircularProgress, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../services/axiosInstance';
import nwLogo from '../assets/images/Infinium.png';
//import nwLogo from '../assets/images/logo.png';
import splashImage from '../assets/images/infiniumsplash.png';

const AdminLoginPage = ({ setAuthToken }) => {
    const { instance } = useMsal();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [password, setPassword] = useState('');
    const [msalResult, setMsalResult] = useState(null);

    const handleMicrosoftLogin = async () => {
        setLoading(true);
        setError('');
        try {
            const result = await instance.loginPopup(loginRequest);
            setMsalResult(result);  // store result, show password field
        } catch (err) {
            console.error('MSAL error:', err);
            setError('Microsoft login failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError('');
        try {
            const response = await axiosInstance.post('/auth/admin-login', {
                accessToken: msalResult.idToken,
                password
            });

            const { token, userId, role, client } = response.data;

            localStorage.setItem('token', token);
            localStorage.setItem('userId', userId);
            localStorage.setItem('client', client);
            localStorage.setItem('role', role);

            setAuthToken(token);
            navigate(`/registeredUsers/${client}`);
        } catch (err) {
            console.error('Admin login error:', err);
            setError('Login failed. Make sure you are using an authorised Infinium account.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box position="relative" height="100vh" overflow="hidden">
            {/* Logo */}
            <Box sx={{ position: 'absolute', top: 15, left: 15, zIndex: 10 }}>
                <a href="https://infinium.consulting/" target="_blank" rel="noopener noreferrer">
                    <img src={nwLogo} alt="Infinium Logo" style={{ height: '45px' }} />
                </a>
            </Box>

            {/* Full Background Image */}
            <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                <img src={splashImage} alt="splash" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </Box>

            {/* Admin Login Form */}
            <Box sx={{ position: 'absolute', top: '8%', left: '4%', zIndex: 5 }}>
                <Card sx={{ p: 4, borderRadius: 4, boxShadow: 8, width: 380 }}>
                    <CardContent>
                        <Typography variant="h4" fontWeight="bold" gutterBottom>
                            Admin Login
                        </Typography>
                        <Typography color="text.secondary" variant="body2" gutterBottom>
                            Sign in with your Infinium Microsoft account
                        </Typography>

                        {error && (
                            <Typography color="error" variant="body2" sx={{ mb: 2 }}>
                                {error}
                            </Typography>
                        )}

                        {/* Step 1 - Microsoft login */}
                        {!msalResult ? (
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={handleMicrosoftLogin}
                                disabled={loading}
                                sx={{ mt: 2 }}
                            >
                                {loading ? <CircularProgress size={24} color="inherit" /> : 'Sign in with Microsoft'}
                            </Button>
                        ) : (
                            /* Step 2 - Password */
                            <form onSubmit={handleSubmit}>
                                <Typography variant="body2" color="success.main" sx={{ mb: 2 }}>
                                    ✅ Microsoft account verified
                                </Typography>
                                <TextField
                                    label="Admin Password"
                                    type="password"
                                    fullWidth
                                    margin="normal"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    autoFocus
                                />
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    sx={{ mt: 2 }}
                                    disabled={loading}
                                >
                                    {loading ? <CircularProgress size={24} color="inherit" /> : 'Login'}
                                </Button>
                            </form>
                        )}
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};

export default AdminLoginPage;